export const STAGE_COLORS = {
  Unknown: "#5A6272",
  Emerging: "#8B93A3",
  "Early Conviction": "#2BD97C",
  Consensus: "#E8EBF0",
  Crowded: "#E3A44A",
  Fading: "#C75E5E",
};

export const STAGES = ["Unknown", "Emerging", "Early Conviction", "Consensus", "Crowded", "Fading"];

export const TAPE_COLORS = { quiet: "#2BD97C", neutral: "#8B93A3", hot: "#E3A44A", none: "#5A6272" };
export const TAPE_LABELS = { quiet: "Quiet", neutral: "Neutral", hot: "Hot", none: "No options" };

export default function StageBadge({ stage, size = "sm" }) {
  const color = STAGE_COLORS[stage] || "#5A6272";
  return (
    <span
      data-testid={`stage-badge-${stage?.replaceAll(" ", "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 font-mono uppercase tracking-wider rounded-full border ${
        size === "sm" ? "text-[10px] px-2.5 py-1" : "text-xs px-3 py-1.5"
      }`}
      style={{ color, borderColor: `${color}55`, background: `${color}12` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: color }} />
      {stage}
    </span>
  );
}
